import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
  Grid, Typography
} from '@mui/material';
import MetricChartItem from "../dashboard/metric-chart-item";
import { getTopologicNodes } from '../../store/fuse/monitoreo';
import LoadingOverlay from "../loading-overlay";
import {
  getDashboardMetrics, 
  setDashboardFiltersSelected, 
} from '../../store/fuse/dashboard';
import DashboardFilter from "../dashboard/filter";


const GraficasDesempeno = (props) => {
  const dispatch = useDispatch();
  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);
  const filtersSelected = useSelector((state) => state?.fuse?.dashboard?.dashboard?.filters?.filtersSelected);
  const [loading, setLoading] = useState(true);
  const nodes = useSelector((state) => state?.fuse?.monitoreo?.topologicNodes);
  const [inmueble, setInmueble] = useState('');
  const { inmuebles, regiones, grupos, nodos } = useSelector((state) => state?.fuse?.filter?.filter?.filters);
  const [region, setRegion] = useState('');
  const [grupo, setGrupo] = useState('');
  const [nodo, setNodo] = useState('');
  const [nodoInfo, setNodoInfo] = useState({});
  const [dateInit, setDateInit] = useState();
  const [dateEnd, setDateEnd] = useState();
  const [refreshKey, setRefreshKey] = useState(0);
  const [nodesSelect, setNodesSelect] = useState([]);

  useEffect(() => {
    dispatch(getDashboardMetrics());
    dispatch(getTopologicNodes(filtersSelected));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    Promise.all([
      dispatch(getDashboardMetrics()),
      dispatch(getTopologicNodes(filtersSelected)),
    ]).finally(() => {
      // Marca como completo después de que ambas acciones terminen
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    fetchAllData();
    const matchCurrentFiltersWithPreviousSelections = () => {
      if (filtersSelected.region) {
        const regionSelected = regiones.find((regionObj) => regionObj.regionId === filtersSelected.region);
        setRegion(regionSelected.regionId);
      }
      if (filtersSelected.grupo) {
        const groupSelected = grupos.find((grupoObj) => grupoObj.grupoInmuebleId === filtersSelected.grupo);
        setGrupo(groupSelected.grupoInmuebleId);
      }
      if (filtersSelected.inmueble) {
        const inmuebleSelected = inmuebles.find((grupoObj) => grupoObj.inmuebleId === filtersSelected.inmueble);
        setInmueble(inmuebleSelected.inmuebleId);
      }
      if (filtersSelected.nodo) {
        const nodoSelected = nodos.find((nodoObj) => nodoObj.nodeId === parseInt(filtersSelected.nodo, 10));
        setNodoInfo(nodoSelected)
        setNodo(nodoSelected.nodeId)
      }
    };
    matchCurrentFiltersWithPreviousSelections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersSelected]);

  const fetchAllData = () => {
    setNodoInfo({})
    dispatch(getTopologicNodes(filtersSelected));
  };

  const nodeSend = () => {
    const nodesSel = typeof nodoInfo === 'object' && nodoInfo !== null && 'nodeId' in nodoInfo
      ? [{ ...nodoInfo, id: String(nodoInfo.nodeId), nodo: nodoInfo.dsNodo }]
      : nodes;
    return nodesSel
  }

  useEffect(() => {
    const updatedNodes = nodeSend();
    setNodesSelect(updatedNodes);
    setRefreshKey((prev) => prev + 1); 
  }, [nodes]);
  
  return (
    <>
      {loading ? (
        <LoadingOverlay />
      ) : (
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={21} style={{ alignItems: 'center',  backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'rgb(238, 242, 248)' }}>
          <Typography variant="h5" sx={{  padding: 5}}>
            Nota: Los gráficos pueden tardar en cargarse debido a la cantidad de datos procesados.
          </Typography>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={21} style={{ alignItems: 'center' }}>
          <DashboardFilter
            currentFilters={{ inmueble, region, grupo, nodo, dateInit, dateEnd }}
            filtersSetters={{ setInmueble, setRegion, setGrupo, setNodo, setDateInit, setDateEnd }}
            filtersSelected={filtersSelected}
            setFilters={setDashboardFiltersSelected}
            fetchAllData={fetchAllData}
          />
        </Grid>
        <Grid item lg={11} md={11} sm={11} xs={11} style={{ alignItems: 'center'}}>
          <MetricChartItem
            key={refreshKey}
            nodes={nodesSelect} filters={filtersSelected} showDates order={0}  lg/>
        </Grid>
      </Grid>
      )}
    </>
  );
}

export default GraficasDesempeno;